import React, { FunctionComponent } from 'react';
import { Rectangular } from '@Components/Skeleton/Skeleton.styled';

const CardInstallmentPrice: FunctionComponent = () => {
	return <Rectangular width="100%" height={22} />;
};

export default CardInstallmentPrice;
